module.exports = __webpack_public_path__ + "static/media/ordinateur-portable.ffea5df7.svg";